<template>
  <Layout>
    <section class="filter-box filter-box--highlights"></section>
    <div class="no-results-found">
      <div class="container">
        <div class="no-results-found__content">
          <div class="no-results-found__content-c">
            <img
              class="no-results-found__img"
              src="@/assets.app/images/no-results.svg"
              alt=""
            />
            <h2 class="no-results-found__title">Page not found...</h2>
            <p class="no-results-found__text">
              Page not found, but you can find some books and pages
              <router-link
                :to="{ name: 'books' }"
                class="no-results-found__link"
                >here</router-link
              >
            </p>
            <router-link :to="{ name: 'books' }">-- Open books </router-link>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import Layout from '@/app/components/Layout.vue'
</script>
